
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// import PropTypes from 'prop-types';
import LoadingState from '../../components/common/loading-state';
import config from '../../../src/globs/config';
import { getInstrumentedAxiosInstance } from '../../../src/globs/ajax-proxy';


const Settings = (props) => {
  const dispatch = useDispatch();
  const [notificationSetting, setNotificationSetting] = useState(props.user.enable_order_notification);
  const [showLoader, setshowLoader] = useState(false);

  const backPage = () => {
    props.history.replace('/home-page')
  }

  const handleNotificationSetting = () => {
    setNotificationSetting(!notificationSetting);
    setshowLoader(true)
    const url = `${config.apiContextPath}/sales_officers/${props.user.id}`;
    getInstrumentedAxiosInstance().patch(url, {enable_order_notification : !notificationSetting})
    .then((res) => {
      console.log('res', res);
      setshowLoader(false);
      dispatch({ type: 'UPDATE_USER', payload: { enable_order_notification: !notificationSetting } }); 
    })
    .catch(err => {
      setshowLoader(false);
      console.log('error', err)
    })
  }
  return (
    <div>
      <div className="lr-main-view__header">
        <button type="button" className="lr-main-view__header-title" onClick={backPage}>
          <span className="icon-back"></span><span>Settings</span>
        </button>
      </div>
      <div className="setting-list">
        <span>Order Notification</span>
        <span className="toggle-switch-container">
          <label htmlFor="push_notification" className="switch-label">
            <input
              id="push_notification"
              type="checkbox"
              checked={notificationSetting}
              onChange={() => handleNotificationSetting(!notificationSetting)}
            />
            <span className="toggle-switch">
              <span className="switch-off-text"><span>OFF</span></span>
              <span className="switch-on-text"><span>ON</span></span>
            </span>
          </label>
        </span>
      </div>
      {
        showLoader &&
        <div>
          <LoadingState />
          <div className="loadingContainer" />
        </div>
      }
    </div>
  )
}

// Settings.propTypes = {
//   user: PropTypes.shape({
//     enable_order_notification: PropTypes.bool,
//   }),
//   history: PropTypes.shape({
//     replace: PropTypes.func(),
//   })
// }

export default Settings;